// products modules
import axios from '@/api/http_client';
import { SEARCH_PRODUCT_URL } from '../../api/url.js';

// initial state
const state = {
}

// actions
const actions = {
  fetchProducts: ({ commit }, {name,company_id,warehouse_id}) => axios({ url: `${SEARCH_PRODUCT_URL}${name}&warehouse_id=${warehouse_id}&company_id=${company_id}`, method: 'GET' }),
};

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js